<template>
  <b-modal
    id="premiumUpgradeModal"
    ref="premiumUpgradeModal"
    title="Premium Feature"
    ok-title="Upgrade Now"
    cancel-title="Maybe Later"
    @ok="goToUpgrade"
    centered
  >
    <div class="premium-modal-content">
      <div class="premium-icon">
        <b-icon icon="star-fill" font-scale="3" variant="warning" />
      </div>
      
      <h5 class="mt-3 mb-3">{{ featureName }}</h5>
      
      <p class="text-muted">{{ featureDescription }}</p>
      
      <div class="premium-benefits mt-4">
        <h6>Premium Benefits:</h6>
        <ul class="benefits-list">
          <li v-for="benefit in featureBenefits" :key="benefit">
            <b-icon icon="check-circle-fill" variant="success" /> {{ benefit }}
          </li>
        </ul>
        <p v-if="crossSell" class="cross-sell mt-2 mb-0 text-muted small">{{ crossSell }}</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
// 20260125 -- Copilot (Claude Sonnet 4.5) -- Created premium feature gate modal
// WHY: Show upgrade prompt when free users try to access premium features
// 20260315 -- Copilot (Claude Sonnet 4.6) -- Added featureBenefits and crossSell props for per-feature content
export default {
  name: 'PremiumUpgradeModal',
  props: {
    featureName: {
      type: String,
      default: 'This Feature'
    },
    featureDescription: {
      type: String,
      default: 'This feature is available to Premium subscribers.'
    },
    featureBenefits: {
      type: Array,
      default: () => []
    },
    crossSell: {
      type: String,
      default: ''
    }
  },
  methods: {
    goToUpgrade() {
      this.$router.push('/profile#subscription')
    },
    show() {
      this.$refs.premiumUpgradeModal.show()
    }
  }
}
</script>

<style scoped>
.premium-modal-content {
  text-align: center;
}

.premium-icon {
  padding: 20px;
}

.premium-benefits {
  text-align: left;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.premium-benefits h6 {
  margin-bottom: 12px;
  font-weight: 600;
}

.benefits-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.benefits-list li {
  padding: 6px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
